/**
 * This is the Google Analytics service
 */
const $google = ['$rootScope', '$document', function ($rootScope, $document) {
    window.dataLayer = window.dataLayer || [];

    this.gtag = function () {
        window.dataLayer.push(arguments);
    };

    this.load = countryCode => {
        const trackingId = countryCode === 'IN' ? 'G-VDQ8E48EVM' : 'G-XPB1JK7D9X';
        const optimizeId = countryCode === 'IN' ? null : 'OPT-MW3WDNG';

        const document = $document[0];

        // Load the gtag script asynchronously
        const analytics = document.createElement('script');
        analytics.async = 1;
        analytics.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackingId;
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(analytics, firstScript);

        // Initialize the tracker
        this.gtag('js', new Date());
        this.gtag('config', trackingId, {
            optimize_id: optimizeId,
            anonymize_ip: true,
        });

        if (optimizeId) {
            // Our own implementation of Google's anti-flicker script using the ng-no-flicker directive
            $rootScope.$broadcast('google:toggleExperiments', false);
            const loaded = () => {
                $rootScope.$broadcast('google:toggleExperiments', true);
            };
            const timeout = 4000;

            window.dataLayer.hide = {
                [optimizeId]: true,
                start: Date.now(),
                end: loaded,
                timeout,
            };
            setTimeout(() => {
                loaded();
                window.dataLayer.hide.end = null;
            }, timeout);
        }
    };
}];

export default $google;
